import { _CreditAccountvdos } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { _Ability, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { QuickTurnSelectCustomerType } from "./Componentes/QuickTurnSelectCustomerType";
import { useEffect, useState } from "react";
import { QuikcTurnSelectAttentionOfficeByChannelType } from "./Componentes/QuikcTurnSelectAttentionOfficeByChannelType";
import { SelectAttentionServiceCodeTree } from "./Componentes/SelectAttentionService/SelectAttentionServiceCodeTree";
import { CardTaps } from "../../../../../../modules/theme/Component/CardTaps";
import { PrintJson } from "../../../../../../modules/theme/Component/PrintJson";
import { SelectCardAvailableAppointmentDates } from "./Componentes/SelectCardAvailableAppointmentDates/SelectCardAvailableAppointmentDates";
import { SelectCardAppointments } from "./Componentes/SelectCardAppointments/SelectCardAppointments";
import { BasicButton } from "../../../../../../modules/theme/Component/BasicButton";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _QuickturnAppointment } from "../../../../../../core/services/dataBean/QuickEntityCatalog";
import { toast } from "react-toastify";
import "./QuickTurnStart.css";
import { Alert } from "../../../../../../modules/theme/Component/Alert";
import { SelectAttentionServiceCardTree } from "./Componentes/SelectAttentionCardService/SelectAttentionServiceCardTree";
import { AttentionServiceCardTree } from "./Componentes/SelectAttentionCardService/AttentionServiceCardTree/AttentionServiceCardTree";


interface Props {
    idAccount?: number;
    ChannelAtention?: number;
}

interface formStart {
    IDCustomerType: number;
    AttentionOffice: number;
    IDLnService: number;
    ServiceName: string;

    SelectedDay: any;
    DayName: string;

    FromDate: any;
    UptoDate: any;
    SelectedIDAttentionPoint: number;
    IDLnSelected: number;
    IDAttentionTimeLapse: number;
}

export const QuickTurnStart = ({ idAccount, ChannelAtention }: Props) => {

    const { instance } = useDataBean(_QuickturnAppointment)

    const [lista, setLista] = useState<any[]>([]);
    const [bean, setBean] = useState<Partial<formStart>>({});
    const [response, setResponse] = useState<any>({});

    const [indexTap, setIndexTap] = useState(0);

    const taps = [
        { id: 0, name: 'Tramite', disable: false },
        { id: 1, name: 'Fecha Disponibles', disable: false },
        // { id: 2, name: 'Asesor Disponible', disable: false },
        { id: 2, name: 'Horas Disponibles', disable: false },
        { id: 3, name: 'Solicitar', disable: false },
    ];

    useEffect(() => { getTurns() }, [])

    const getTurns = () => {
        instance.getAppointmentByAccount(null, null, _single.getAccountID(), 0).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(error => { toast.error(error) })
    }

    const buttonClick = () => {
        if (indexTap === 0) {
            if (!bean.IDLnService) {
                toast.error("Debe seleccionar un servicio para continuar");
                return;
            }
            setIndexTap(prev => prev + 1);
            return;
        }

        if (indexTap === 1) {
            if (!bean.SelectedDay) {
                toast.error("Debe seleccionar una fecha para continuar");
                return;
            }
            setIndexTap(prev => prev + 1);
            return;
        }

        if (indexTap === 2) {
            if (!bean.IDAttentionTimeLapse) {
                toast.error("Debe seleccionar un horario para continuar");
                return;
            }
            setIndexTap(prev => prev + 1);
            return;
        }

        if (indexTap === 3) {
            setAppointment();
        }
    };


    const nameButton = () => {
        switch (indexTap) {
            case 0:
                return "Validar fechas";
            case 1:
                return "Seleccionar Fecha";
            case 2:
                return "Seleccionar Horario";
            case 3:
                return "Confirmar Cita";

            default:
                return "Sin Acción";
        }
    }

    const setAppointment = () => {
        instance.assignAppointment(bean.IDLnSelected, bean.SelectedIDAttentionPoint, bean.IDAttentionTimeLapse, bean.FromDate, bean.UptoDate, idAccount ?? _single.getAccountID(), bean.IDCustomerType, ChannelAtention, null, null, _single.getCurrenDate()).then(
            (resp) => {
                setResponse(resp);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const initTurn = (appoint: any) => {
        instance.createAttentionTicketFromAppointment(appoint.IDAppointment, _single.getCurrenDate()).then(
            (resp) => {
                console.log(resp);
                getTurns();
            }
        ).catch(err => { toast.error(err) })
    }

    const cancelTurn = (appoint: any) => {
        instance.cancelAppointment(appoint.IDAppointment, appoint.AgendaRequestDate, _single.getAccountID(), "").then(
            (resp) => {
                console.log(resp)
                getTurns();
            }
        ).catch(resp => { toast.error(resp) })
    }

    return lista.length > 0 ? (
        <div className="appointment-list">
            <Alert children={`Ya tienes ${lista.length} ${lista.length === 1 ? "agendamiento activo" : "agendamietos activos"}`} clase="info" />
        </div>
    ) :
        (!response.IDAppointment ?
            <CardTaps index={indexTap} taps={taps} updateIndex={setIndexTap} >
                {indexTap === 0 &&
                    <div className="row">
                        <div className="col-md-6">
                            <QuickTurnSelectCustomerType idSelector={bean.IDCustomerType} onChange={(e) => { setBean({ ...bean, IDCustomerType: e }) }} label="Tipo de Cliente" />
                        </div>
                        <div className="col-md-6">
                            <QuikcTurnSelectAttentionOfficeByChannelType channelType={ChannelAtention} idSelector={bean.AttentionOffice} onChange={(e) => { setBean({ ...bean, AttentionOffice: e }) }} />
                        </div>
                        <div className="col-md-12 mt-2">
                            <AttentionServiceCardTree
                                idAttentionPoint={bean.AttentionOffice}
                                onSelect={(e) => { setBean({ ...bean, IDLnService: e.IDLn, ServiceName: e.Name }) }}
                            />
                {/* <PrintJson json={bean} /> */}
                        </div>
                    </div>
                }
                {indexTap === 1 &&
                    <SelectCardAvailableAppointmentDates ServiceIDLn={bean.IDLnService} onChange={(e) => { setBean({ ...bean, SelectedDay: e.Date, DayName: e.DayName }) }} />
                }
                {indexTap === 2 &&
                    <SelectCardAppointments
                        SelectedDay={bean.SelectedDay}
                        ServiceIDLn={bean.IDLnService}
                        onChange={
                            (e) => {
                                setBean({
                                    ...bean,
                                    SelectedIDAttentionPoint: e.IDAttentionPoint,
                                    IDAttentionTimeLapse: e.IDAttentionTimeLapse,
                                    IDLnSelected: e.IDLn,
                                    FromDate: e.FromDate,
                                    UptoDate: e.UntilDate
                                })
                            }} />
                }
                {indexTap === 3 && (
                    <div className="row mt-3">

                        <div className="col-md-6 mb-3">
                            <h4>Resumen Agenda</h4>
                            <hr />

                            <p className="mb-1">
                                <strong>
                                    {bean.DayName} {bean.SelectedDay}
                                </strong>
                            </p>

                            <p className="mb-0">
                                <strong>Horario</strong>
                            </p>
                            <p className="mb-0">
                                {bean.FromDate?.split(" ")[1]?.substring(0, 5)} - {bean.UptoDate?.split(" ")[1]?.substring(0, 5)}
                            </p>
                        </div>
                    </div>
                )}

                <div className="d-flex justify-content-between mt-4">
                    <div>
                        {indexTap > 0 && (
                            <BasicButton timeStopClickSeg={1} eventClick={() => setIndexTap(prev => prev - 1)} icon="ri-arrow-left-fill" children={"Volver"} />
                        )}
                    </div>

                    <div>
                        <BasicButton timeStopClickSeg={1} eventClick={() => buttonClick()} icon="ri-arrow-right-fill" children={`${nameButton()}`} />
                    </div>
                </div>
            </CardTaps>
            : (
                <div className="col-md-12 mb-3">
                    <h4>Confirmación Agendamiento</h4>
                    <hr />

                    <p className="mb-1">
                        <strong>Señor :</strong> {_single.getAccount().EntityName}
                    </p>
                    <p className="mb-1">
                        <strong>Servicio :</strong> {bean.ServiceName}
                    </p>
                    <p className="mb-1">
                        <strong>Sede :</strong> {response.AttentionOfficeName}
                    </p>
                    <p className="mb-1">
                        <strong>Tipo de Atención :</strong> {response.ChannelTypeName}
                    </p>
                    <p className="mb-3">
                        <strong>Estado Agenda :</strong> AGENDADO
                    </p>

                    <div className="alert alert-success mb-0">
                        Su cita fue agendada correctamente.
                    </div>
                </div>
            )
        );
};
